import {request} from "./request";

// 获取产品列表
export function getGoodsList(pagesize, page, name, class_id, search_time) {
    return request({
        url: '/hkt/goods/get_goods_list',
        params: {
            pagesize,
            page,
            name,
            class_id,
            search_time
        }
    })
}
// 获取产品列表2
// pagesize	是	int	每页数量
// name	否	string	标题
// class_id	否	int	类别id
// search_time	否	json	时间
// sort_type	否	int	排序类型
export function getGoodsLis2(params) {
    return request({
        url: '/hkt/goods/get_goods_list',
        params,
    })
}
// 删除产品
export function delGoods(goods_id) {
    return request({
        url: '/hkt/goods/del_goods',
        params: {
            goods_id,
        }
    })
}
// 添加产品
// 参数名	必选	类型	说明
// name	是	string	名称
// describe	否	string	描述
// is_show	是	int	是否前台显示
// is_state	是	int	是否上架
// is_recommend	是	int	是否推荐
// price_type	是	int	价格类型
// price	否	number	价格
// class_id	是	int	类别id
// introduce	否	string	介绍
// images	是	string	图片id	2,5,1,5
// code	否	string	编码
// unit_id	是	int	单位id
// is_unit	是	int	多单位开关
// unit	否	string	单位
// is_spec	是	int	是否多规格
// spec	否	string	规格
// spec_details	否	string	规格明细
export function addGoods(data) {
    return request({
        url: '/hkt/goods/add_goods',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
}
// 获取单个产品
export function getGoods(goods_id) {
    return request({
        url: '/hkt/goods/get_goods',
        params: {
            goods_id,
        }
    })
}
// 修改产品
export function editGoods(data) {
    return request({
        url: '/hkt/goods/edit_goods',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 获取全部产品类别
export function getAllGoodsClassList() {
    return request({
        url: '/hkt/goodsclass/get_goods_class_list',

    })
}
// 获取产品类别
export function getGoodsClassList(pagesize, page) {
    return request({
        url: '/hkt/goodsclass/get_goods_class_list',
        params: {
            pagesize,
            page
        }
    })
}
// 添加产品类别
export function addGoodsClass(name, is_show) {
    return request({
        url: '/hkt/goodsclass/add_goods_class',
        params: {
            name,
            is_show
        }
    })
}
// 编辑产品类别
export function editGoodsClass(class_id, name, is_show) {
    return request({
        url: '/hkt/goodsclass/edit_goods_class',
        params: {
            class_id,
            name,
            is_show
        }
    })
}
// 编辑产品类别
export function delGoodsClass(class_id) {
    return request({
        url: '/hkt/goodsclass/del_goods_class',
        params: {
            class_id,
        }
    })
}

// 编辑产品类别
export function getGoodsCode(goods_id) {
    return request({
        url: '/hkt/goods/get_goods_code',
        params: {
            goods_id,
        }
    })
}

// 操作
export function operateGoods(goods_id, operate_type) {
    return request({
        url: '/hkt/goods/operate_goods',
        params: {
            goods_id,
            operate_type
        }
    })
}

export function getGoodsRecord(pagesize, page, name, search_time) {
    return request({
        url: '/hkt/goods/get_goods_record',
        params: {
            pagesize,
            page,
            name,
            search_time
        }
    })
}
export function getGoods2Record(params) {
    return request({
        url: '/hkt/goods/get_goods_record',
        params,
    })
}
export function changeGoodsState(goods_id, is_state) {
    return request({
        url: '/hkt/goods/change_goods_state',
        params: {
            goods_id,
            is_state,
        }
    })
}

// 删除商品记录
export function delGoodsRecord(goods_id) {
    return request({
        url: '/hkt/goods/del_goods_record',
        params: {
            goods_id,
        }
    })
}